import React from "react";
import { Select, useI18nContext } from "@procore/core-react";
import type { GanttDateRangeSelectorProps } from "./gantt-date-range-constants";
import {
   DATE_RANGE_OPTIONS,
   NULL_RANGE_LABEL,
   type DateRangeDays,
} from "./gantt-date-range-constants";

export const GanttDateRangeSelector = ({
   selectedRange,
   onRangeChange,
}: GanttDateRangeSelectorProps) => {
   const I18n = useI18nContext();

   const getOptionLabel = (option: (typeof DATE_RANGE_OPTIONS)[number]) => {
      if (option.translationKey === null) return NULL_RANGE_LABEL;
      return I18n.t(option.translationKey, { count: option.count });
   };

   const selectedOption = DATE_RANGE_OPTIONS.find((opt) => opt.days === selectedRange);
   const selectedLabel = selectedOption ? getOptionLabel(selectedOption) : NULL_RANGE_LABEL;

   return (
      <Select
         label={selectedLabel}
         onSelect={({ item }: { item: DateRangeDays }) => onRangeChange(item)}
         aria-label="date range selector"
         style={{ width: "120px" }}
      >
         {DATE_RANGE_OPTIONS.map((option) => (
            <Select.Option
               key={option.days ?? NULL_RANGE_LABEL}
               value={option.days}
               selected={option.days === selectedRange}
            >
               {getOptionLabel(option)}
            </Select.Option>
         ))}
      </Select>
   );
};
